function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16.29,
    height: 8.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.866
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 4.33
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.66,
    width: 16.29,
    height: 8.79,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.2557142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 13.055
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.45,
    width: 16.29,
    height: 9.03,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 21.965
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26.48,
    width: 16.29,
    height: 9.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.3114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 31.07
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.66,
    width: 16.29,
    height: 11.56,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 41.44
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 47.22,
    width: 16.29,
    height: 11.92,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 53.18
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59.14,
    width: 16.29,
    height: 13.94,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 66.11
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.08,
    width: 16.29,
    height: 15.38,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1830769230769231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 80.77
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.46,
    width: 16.29,
    height: 16.07,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.214
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 96.49499999999999
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 104.53,
    width: 16.29,
    height: 18.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 113.725
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 122.92,
    width: 16.29,
    height: 18.5,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 132.17000000000002
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 141.42,
    width: 16.29,
    height: 18.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 150.75
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 160.08,
    width: 16.29,
    height: 20.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 170.4
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180.72,
    width: 16.29,
    height: 22.24,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 191.84
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 202.97,
    width: 16.29,
    height: 22.5,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.03625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 214.22
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 225.46,
    width: 16.29,
    height: 22.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 236.79500000000002
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 248.13,
    width: 16.29,
    height: 23.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 259.90999999999997
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 271.7,
    width: 16.29,
    height: 23.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 283.63
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 295.55,
    width: 16.29,
    height: 25.12,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.03625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 308.11
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 320.68,
    width: 16.29,
    height: 26.82,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 334.09000000000003
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 347.5,
    width: 16.29,
    height: 26.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 360.96
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 374.42,
    width: 16.29,
    height: 27,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 387.92
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 401.41,
    width: 16.29,
    height: 27.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 415.25
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 429.09,
    width: 16.29,
    height: 27.75,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.03625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 442.965
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 456.85,
    width: 16.29,
    height: 28.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 471.20000000000005
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 485.55,
    width: 16.29,
    height: 28.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.629
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 499.98
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 514.41,
    width: 16.29,
    height: 29.83,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.03625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 529.3249999999999
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 544.24,
    width: 16.29,
    height: 30.8,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 559.64
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 575.04,
    width: 16.29,
    height: 30.85,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.03625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 590.4649999999999
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 605.89,
    width: 16.29,
    height: 31.01,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 621.395
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 636.9,
    width: 16.29,
    height: 31.1,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 652.4499999999999
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 667.99,
    width: 16.29,
    height: 32.01,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.145,
    y: 683.995
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 0,
    width: 20.5,
    height: 25.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9285714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 26.54,
    y: 12.73
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.79,
    y: 0,
    width: 20.69,
    height: 25.46,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.955714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.135,
    y: 12.73
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.48,
    y: 0,
    width: 20.71,
    height: 25.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9585714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 67.835,
    y: 12.73
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.19,
    y: 0,
    width: 21.32,
    height: 25.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.045714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.85,
    y: 12.73
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.51,
    y: 0,
    width: 22.01,
    height: 25.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1442857142857146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.515,
    y: 12.73
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.52,
    y: 0,
    width: 22.1,
    height: 25.46,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.57,
    y: 12.73
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 143.62,
    y: 0,
    width: 22.29,
    height: 25.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.184285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 154.76500000000001,
    y: 12.73
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.91,
    y: 0,
    width: 22.41,
    height: 25.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.482
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.115,
    y: 12.73
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.32,
    y: 0,
    width: 23.06,
    height: 25.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.612
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 199.85,
    y: 12.73
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.38,
    y: 0,
    width: 24.56,
    height: 25.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.912
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.66,
    y: 12.73
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.94,
    y: 0,
    width: 25.44,
    height: 25.46,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.66,
    y: 12.73
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.39,
    y: 0,
    width: 25.68,
    height: 25.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.22999999999996,
    y: 12.73
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 287.07,
    y: 0,
    width: 26.05,
    height: 25.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.09499999999997,
    y: 12.73
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.11,
    y: 0,
    width: 26.31,
    height: 25.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.828888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.265,
    y: 12.73
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.43,
    y: 0,
    width: 26.49,
    height: 25.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.243333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.675,
    y: 12.73
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.92,
    y: 0,
    width: 27.64,
    height: 25.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.243333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 379.74,
    y: 12.73
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 393.56,
    y: 0,
    width: 27.85,
    height: 25.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0920000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.485,
    y: 12.73
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.41,
    y: 0,
    width: 28.1,
    height: 25.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.365
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.46000000000004,
    y: 12.73
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 449.5,
    y: 0,
    width: 28.24,
    height: 25.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5460000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.62,
    y: 12.73
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.75,
    y: 0,
    width: 29.82,
    height: 25.46,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.243333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.66,
    y: 12.73
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.57,
    y: 0,
    width: 30.78,
    height: 25.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0920000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.96,
    y: 12.73
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.35,
    y: 0,
    width: 31.36,
    height: 25.46,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.03,
    y: 12.73
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.7,
    y: 0,
    width: 32.29,
    height: 25.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.845,
    y: 12.73
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602,
    y: 0,
    width: 32.6,
    height: 25.46,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.0920000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.3,
    y: 12.73
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.6,
    y: 0,
    width: 32.64,
    height: 25.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6371428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.9200000000001,
    y: 12.73
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 667.23,
    y: 0,
    width: 32.77,
    height: 25.46,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.615,
    y: 12.73
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 25.46,
    width: 31.48,
    height: 26.54,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.654
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 38.730000000000004
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 52,
    width: 31.48,
    height: 27.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.988571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 65.96000000000001
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 79.92,
    width: 31.48,
    height: 27.92,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.653333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 93.88
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 107.85,
    width: 31.48,
    height: 29.45,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.3625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 122.57499999999999
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 137.29,
    width: 31.48,
    height: 29.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.894
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 152.02499999999998
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 166.76,
    width: 31.48,
    height: 30.03,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 181.77499999999998
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 196.79,
    width: 31.48,
    height: 30.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 212.02499999999998
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 227.25,
    width: 31.48,
    height: 30.63,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1259999999999994
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 242.565
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 257.88,
    width: 31.48,
    height: 30.81,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 273.28499999999997
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 288.7,
    width: 31.48,
    height: 31.29,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.258
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 304.34499999999997
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 319.99,
    width: 31.48,
    height: 31.79,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 335.885
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 351.78,
    width: 31.48,
    height: 32.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.246666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 367.97999999999996
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 384.19,
    width: 31.48,
    height: 32.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.296
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 400.675
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 417.16,
    width: 31.48,
    height: 34.14,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.246666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 434.23
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 451.3,
    width: 31.48,
    height: 34.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 468.43
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 485.56,
    width: 31.48,
    height: 34.66,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.296
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 502.89
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 520.22,
    width: 31.48,
    height: 35.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.497142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 537.825
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 555.43,
    width: 31.48,
    height: 35.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 573.1099999999999
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 590.79,
    width: 31.48,
    height: 36.1,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.246666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 608.8399999999999
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 626.9,
    width: 31.48,
    height: 36.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.296
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 645.13
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.29,
    y: 663.36,
    width: 31.48,
    height: 36.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.935
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32.03,
    y: 681.6800000000001
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 25.46,
    width: 32.31,
    height: 36.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2310000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 63.925000000000004,
    y: 43.480000000000004
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.09,
    y: 25.46,
    width: 32.34,
    height: 36.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5933333333333337
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.26,
    y: 43.480000000000004
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.42,
    y: 25.46,
    width: 33.4,
    height: 36.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 43.480000000000004
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.82,
    y: 25.46,
    width: 33.42,
    height: 36.04,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.53,
    y: 43.480000000000004
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.25,
    y: 25.46,
    width: 33.58,
    height: 36.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3579999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.04,
    y: 43.480000000000004
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.83,
    y: 25.46,
    width: 33.74,
    height: 36.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.748
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.70000000000002,
    y: 43.480000000000004
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.57,
    y: 25.46,
    width: 34.93,
    height: 36.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.986
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.03499999999997,
    y: 43.480000000000004
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.49,
    y: 25.46,
    width: 35.2,
    height: 36.04,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.040000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.09000000000003,
    y: 43.480000000000004
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.7,
    y: 25.46,
    width: 36.29,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 334.84499999999997,
    y: 43.480000000000004
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 352.99,
    y: 25.46,
    width: 36.59,
    height: 36.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.148571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.285,
    y: 43.480000000000004
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.58,
    y: 25.46,
    width: 36.86,
    height: 36.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.148571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.01,
    y: 43.480000000000004
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.44,
    y: 25.46,
    width: 37.18,
    height: 36.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.03,
    y: 43.480000000000004
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.62,
    y: 25.46,
    width: 38,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.208
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 482.62,
    y: 43.480000000000004
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.62,
    y: 25.46,
    width: 39.11,
    height: 36.04,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.208
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.175,
    y: 43.480000000000004
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.73,
    y: 25.46,
    width: 39.35,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.208
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.405,
    y: 43.480000000000004
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.07,
    y: 25.46,
    width: 39.8,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.97,
    y: 43.480000000000004
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.87,
    y: 25.46,
    width: 39.82,
    height: 36.04,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.505
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.78,
    y: 43.480000000000004
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.69,
    y: 25.46,
    width: 40.31,
    height: 36.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.845,
    y: 43.480000000000004
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 61.5,
    width: 41.06,
    height: 35.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.082857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 79.28999999999999
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 97.07,
    width: 41.06,
    height: 36.08,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.215999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 115.10999999999999
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 133.15,
    width: 41.06,
    height: 36.19,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.031666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 151.245
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 169.35,
    width: 41.06,
    height: 36.47,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 187.58499999999998
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 205.82,
    width: 41.06,
    height: 36.84,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 224.24
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 242.66,
    width: 41.06,
    height: 37.66,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.553333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 261.49
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 280.33,
    width: 41.06,
    height: 38.42,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.488571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 299.53999999999996
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 318.75,
    width: 41.06,
    height: 38.63,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4383333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 338.065
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 357.38,
    width: 41.06,
    height: 39.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.845999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 376.995
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 396.61,
    width: 41.06,
    height: 40.77,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 416.995
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 437.38,
    width: 41.06,
    height: 40.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.801666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 457.78499999999997
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 478.19,
    width: 41.06,
    height: 42.45,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 499.415
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 520.64,
    width: 41.06,
    height: 44.57,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.843333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 542.925
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 565.21,
    width: 41.06,
    height: 44.64,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.843333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 587.5300000000001
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 609.85,
    width: 41.06,
    height: 44.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 632.285
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.77,
    y: 654.72,
    width: 41.06,
    height: 45.28,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.265
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 68.30000000000001,
    y: 677.36
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 61.5,
    width: 37.62,
    height: 50.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.374285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 107.64,
    y: 86.755
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126.45,
    y: 61.5,
    width: 38.98,
    height: 50.51,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.3311111111111105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.94,
    y: 86.755
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 165.43,
    y: 61.5,
    width: 41.64,
    height: 50.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.25,
    y: 86.755
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.08,
    y: 61.5,
    width: 41.66,
    height: 50.51,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9433333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.91000000000003,
    y: 86.755
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.74,
    y: 61.5,
    width: 42.78,
    height: 50.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.111428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.13,
    y: 86.755
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.52,
    y: 61.5,
    width: 46.14,
    height: 50.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.59,
    y: 86.755
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.66,
    y: 61.5,
    width: 46.39,
    height: 50.51,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7316666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 360.855,
    y: 86.755
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.06,
    y: 61.5,
    width: 47.5,
    height: 50.51,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.277777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.81,
    y: 86.755
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.55,
    y: 61.5,
    width: 47.51,
    height: 50.51,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.7871428571428565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.305,
    y: 86.755
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.07,
    y: 61.5,
    width: 50.64,
    height: 50.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.215714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.39,
    y: 86.755
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.71,
    y: 61.5,
    width: 52.13,
    height: 50.51,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.418333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.7750000000001,
    y: 86.755
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 581.84,
    y: 61.5,
    width: 56.39,
    height: 50.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.215714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.0350000000001,
    y: 86.755
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.23,
    y: 61.5,
    width: 61.77,
    height: 50.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.31375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.115,
    y: 86.755
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 112.01,
    width: 60.08,
    height: 52.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.831666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.87,
    y: 138.505
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 165,
    width: 60.08,
    height: 54.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.831999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.87,
    y: 192.07999999999998
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 219.16,
    width: 60.08,
    height: 55.15,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.878571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.87,
    y: 246.73499999999999
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 274.32,
    width: 60.08,
    height: 65.16,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.6755555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.87,
    y: 306.9
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 339.47,
    width: 60.08,
    height: 68.23,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.013333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.87,
    y: 373.58500000000004
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 407.71,
    width: 60.08,
    height: 68.41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.87,
    y: 441.91499999999996
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 476.12,
    width: 60.08,
    height: 72.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.013333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.87,
    y: 512.16
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 548.19,
    width: 60.08,
    height: 74.79,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.013333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.87,
    y: 585.585
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.83,
    y: 622.98,
    width: 60.08,
    height: 77.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.87,
    y: 661.49
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.91,
    y: 112.01,
    width: 59.12,
    height: 79.38,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.47,
    y: 151.7
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.03,
    y: 112.01,
    width: 59.17,
    height: 79.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.452857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.615,
    y: 151.7
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.21,
    y: 112.01,
    width: 62.93,
    height: 79.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.992222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298.67499999999995,
    y: 151.7
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.14,
    y: 112.01,
    width: 66.02,
    height: 79.38,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.43142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.15,
    y: 151.7
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.16,
    y: 112.01,
    width: 69.89,
    height: 79.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.648333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.105,
    y: 151.7
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.05,
    y: 112.01,
    width: 75.7,
    height: 79.38,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 503.90000000000003,
    y: 151.7
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.76,
    y: 112.01,
    width: 78.71,
    height: 79.38,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.244285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.115,
    y: 151.7
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.47,
    y: 112.01,
    width: 79.53,
    height: 79.38,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.229999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.235,
    y: 151.7
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.91,
    y: 191.39,
    width: 90.26,
    height: 74.31,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.615714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.04,
    y: 228.545
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.91,
    y: 265.7,
    width: 90.26,
    height: 77.55,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.69375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.04,
    y: 304.47499999999997
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.91,
    y: 343.25,
    width: 90.26,
    height: 81.78,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.04,
    y: 384.14
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.91,
    y: 425.04,
    width: 90.26,
    height: 86.46,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.35142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.04,
    y: 468.27000000000004
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.91,
    y: 511.49,
    width: 90.26,
    height: 93.55,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.894285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.04,
    y: 558.265
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.91,
    y: 605.05,
    width: 90.26,
    height: 94.95,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.565
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 194.04,
    y: 652.525
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.18,
    y: 191.39,
    width: 84.08,
    height: 112.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 281.22,
    y: 247.875
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.26,
    y: 191.39,
    width: 84.28,
    height: 112.97,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.4,
    y: 247.875
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 407.53,
    y: 191.39,
    width: 91.1,
    height: 112.97,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.3875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 453.08,
    y: 247.875
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 498.63,
    y: 191.39,
    width: 96.8,
    height: 112.97,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.03,
    y: 247.875
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595.43,
    y: 191.39,
    width: 104.57,
    height: 112.97,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.938571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.7149999999999,
    y: 247.875
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.18,
    y: 304.36,
    width: 125.95,
    height: 107.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.15500000000003,
    y: 358.33000000000004
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.18,
    y: 412.3,
    width: 125.95,
    height: 287.7,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.74375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 302.15500000000003,
    y: 556.15
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.13,
    y: 304.36,
    width: 166.43,
    height: 246.56,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 448.345,
    y: 427.64
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 531.55,
    y: 304.36,
    width: 168.45,
    height: 246.56,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 42.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.775,
    y: 427.64
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.13,
    y: 550.92,
    width: 334.87,
    height: 149.08,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.846666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.565,
    y: 625.4599999999999
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2004);
export default __webpack_public_path__ + "static/media/2004.579ed516b24c444e2ff4472832a881e9.svg";
export { ForwardRef as ReactComponent };